var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"text-h6 mb-3"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('v-row',[_c('v-col',[_c('base-table',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var attrs = ref.attrs;
var on = ref.on;
return [_c('v-data-table',_vm._g(_vm._b({attrs:{"headers":_vm.headers,"items":_vm.items,"item-key":"id","fixed-header":""}},'v-data-table',attrs,false),on))]}}])},'base-table',_vm.$attrs,false))],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }